<template>
  <div class="promo">
    <div
      class="promo__container"
      :style="singleArticleContainerStyle"
    >
      <!-- Контент должен находиться выше других элементов. Важно для seo. (LH-1368)-->
      <div class="single-article__wrapper">
        <div class="single-article">
          <section class="single-article__content">
            <AdminControlsPanel
              v-if="isAuthenticatedInWordpress"
              class="admin-controls"
              :views-count="viewsCount"
              :edit-link-href="editLinkHref"
              :loading="getLoadingViews(article.id)"
              @click-on-restore-button="updateViewsCount(article.id)"
            />
            <ArticleCard
              class="single-article-card"
              :article="article"
              :title="articleTitle"
              :comments-count="commentsCount"
              :user="user"
              :favorite="favorites"
              :folders="folders"
              :to-comments-link="false"
              :comments-enabled="article.commentsEnabled"
              @favorite-delete="(favorite) => onFavoriteDelete(favorite, article)"
              @favorite-create-folder-and-add="
                (nameFolder) => onFavoriteDelete(nameFolder, article)
              "
              @favorite-create-folder-and-transfer="
                (nameFolder, favorite) =>
                  onFavoriteCreateFolderAndTransfer(nameFolder, favorite, article)
              "
              @favorite-transfer-to-folder="
                (favorite, folder) => onFavoriteTransferToFolder(favorite, folder, article)
              "
              @favorite-add-to-folder="(folder) => onFavoriteAddToFolder(folder, article)"
              @favorite-deferred="onFavoriteDeferred"
              @clicked-on-category="onClickOnCategory"
            />

            <!-- id article указан в JSON+LD -->
            <article
              id="article"
              class="single-article__post-content single-article__content-container"
              @click="checkImageClick"
            >
              <template v-for="(content, idx) in slicedContents">
                <!-- контент статьи-->
                <TheContent
                  v-for="item of content"
                  :key="item.id"
                  :elem="item"
                  :lazy-loading-enabled="true"
                />

                <!-- виджеты внутри контента-->
                <WidgetsRendererContainer
                  v-if="
                    isWidgetsRendererVisible && typeof widgetsInsideContent[idx] !== 'undefined'
                  "
                  :widgets="widgetsInsideContent[idx]"
                />
              </template>
            </article>

            <footer class="article__footer">
              <!-- текст под контентом статьи. Обложка, источник и тп-->
              <ArticleNote
                class="article-note"
                :class="{ 'article-note_empty': !articleNotes.length }"
                :notes="articleNotes"
              />

              <!-- ArticleCardActions-->
              <component
                :is="articleCardComponent"
                class="article__actions"
                in-page-position="bottom"
                event-position="bottom"
                :article-id="article.id"
                :url="article.teaserUrl || article.url"
                :cover-url="
                  article.img && article.img[0] && article.img[0].url ? article.img[0].url : null
                "
                :comments-enabled="article.commentsEnabled && !article.teaserUrl"
                :comments-count="commentsCount"
                :title="articleTitle"
                :user="user"
                :favorite="favorites"
                :folders="folders"
                :can-have-reactions="article.canHaveReactions"
                @favorite-delete="(favorite) => onFavoriteDelete(favorite, article)"
                @favorite-create-folder-and-add="
                  (nameFolder) => onFavoriteDelete(nameFolder, article)
                "
                @favorite-create-folder-and-transfer="
                  (nameFolder, favorite) =>
                    onFavoriteCreateFolderAndTransfer(nameFolder, favorite, article)
                "
                @favorite-transfer-to-folder="
                  (favorite, folder) => onFavoriteTransferToFolder(favorite, folder, article)
                "
                @favorite-add-to-folder="(folder) => onFavoriteAddToFolder(folder, article)"
                @favorite-deferred="onFavoriteDeferred"
              />

              <!-- для шаблона промо-->
              <div class="create-in-container">
                <p
                  v-if="isPromoArticle"
                  class="create-in-container__text"
                >
                  Сделано в&nbsp<a
                    class="create-in-container__link"
                    :href="'/'"
                    >Лайфхакере</a
                  >
                </p>
              </div>
            </footer>
          </section>

          <!-- зона виджетов "над комментариями"-->
          <WidgetsRendererContainer
            v-if="isWidgetsRendererVisible || isAdsException"
            class="widgets above-comments-widgets__container"
            :widgets="aboveCommentsWidgets"
          />

          <!-- комментарии-->
          <CommentsContainer
            v-if="showComments"
            :id="article.id"
            class="comments"
          />

          <!-- зона виджетов "под комментариями"-->
          <WidgetsRendererContainer
            v-if="isWidgetsRendererVisible || isAdsException"
            class="below-comments-widgets__container"
            :widgets="belowCommentsWidgets"
          />
        </div>
      </div>

      <!-- Полноэкранная галерея-->
      <FullScreenGallery
        v-if="isGalleryVisible"
        :image-urls="imagesSrc"
        :srcset="imagesSrcset"
        :current-slide="currentImageId"
        @close="closeGallery"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import GeneralTemplates from './general'; // Берем за основу компонент generalTemplate, но даем ему уникальное имя

  // Берем за основу компонент generalTemplate, но даем ему уникальное имя
  // Без уникального имени может рендериться не корректный шаблон
  export default defineNuxtComponent({
    ...GeneralTemplates,
    name: 'Promo',
  });
</script>

<style lang="scss" scoped>
  $border: 1px solid #e7e7e7;

  @mixin new-tablet() {
    @media (min-width: 961px) {
      @content;
    }
  }

  .promo {
    .single-article {
      cursor: default;
      margin: 0 auto;

      @include tablet {
        background: white;
        border: $border;
      }

      .article__footer,
      &__post-content {
        @include tablet {
          max-width: 640px;
          width: 100%;
          margin: 0 auto;
        }
        @include big-tablet {
          max-width: 780px;
          width: 100%;
        }
      }

      &__content {
        background: white;
      }

      &__wrapper {
        @include tablet {
          background: white;
          max-width: 760px;
          width: 100%;
          margin-left: auto;
          margin-right: auto;
        }

        @include new-tablet {
          max-width: 960px;
          width: 100%;
        }

        @include desktop {
          max-width: 1120px;
          width: 100%;
        }

        @include new-desktop-big {
          max-width: 1280px;
          width: 100%;
        }
      }
    }

    .single-article-card {
      border: none;

      :deep(.article-card__title) {
        @include tablet {
          padding-bottom: 16px;
        }
      }

      :deep(.article-card__title--only) {
        padding-bottom: 24px;
      }
    }

    .admin-controls {
      margin-left: 16px;
      padding-top: 16px;

      @include tablet {
        margin-left: 24px;
      }
    }

    .admin-controls + .single-article-card {
      padding-top: 8px;

      @include tablet {
        padding-top: 12px;
      }
    }

    .single-article__page-content-wrapper {
      background: white;
      padding: 16px 0 32px;
      max-width: 1280px;
      width: 100%;
      margin: 0 auto;

      @include tablet {
        padding: 24px 0 40px;
        border: 1px solid #e7e7e7;
      }

      @include desktop {
        padding: 24px 24px 40px;
      }
    }

    .single-article__page-content {
      max-width: 780px;
      width: 100%;
      margin: 0 auto;
    }

    .article__footer {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      .article-card-actions {
        border-bottom: $border;
        width: 100%;
        margin-bottom: 16px;
        display: flex;
        justify-content: center;
      }
    }

    .article-note {
      width: 100%;
      text-align: center;
      padding: 0;
      margin-top: 0;
      margin-bottom: 0;

      :deep(.item) {
        border: none;

        &:not(:last-child) {
          padding-bottom: 8px;
        }

        // плашка "нашли ошибку" на мобилках display none, поэтому отступ до кнопок шаринга неверный
        // здесь такой костыль
        &:nth-last-child(2) {
          border: none !important;
          padding-bottom: 16px;

          @include desktop {
            padding-bottom: 8px;
          }
        }

        &:last-child {
          padding-bottom: 16px;
        }
      }
    }

    :deep(.typo-info) {
      border-top: 0;
      padding-top: 0 !important;
    }

    :deep(.article-card) {
      @include tablet {
        max-width: none;
      }

      .article-card-actions {
        @include tablet {
          max-width: 592px;
          width: 100%;
          margin: 0 auto;
          padding: 16px 0;
        }

        @include big-tablet {
          max-width: 732px;
          width: 100%;
        }
      }

      .article-card__above-cover {
        @include tablet {
          padding: 0 24px;
        }
      }
    }

    :deep(.article-card__above-cover) {
      @include tablet {
        max-width: 640px;
        width: 100%;
        margin: 0 auto;
      }
      @include big-tablet {
        max-width: 780px;
        width: 100%;
      }
    }

    :deep(.article-card__cover) {
      @include tablet {
        max-width: 732px;
        width: 100%;
      }
      @include new-tablet {
        max-width: 900px;
        width: 100%;
      }
    }

    .create-in-container {
      padding: 0 0 16px;
      font-family: $mainFont;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;

      .create-in-container__text {
        color: #000;
      }

      .create-in-container__link {
        text-decoration: none;

        @include hover {
          text-decoration: underline;
        }

        color: var(--main-color);

        &:visited {
          color: #7142d6;
        }
      }
    }
  }
</style>
